<template>
  <ul v-if="mainNav && mainNav.length > 0" class="grow relative" ref="navContainer" tabindex="-1" role="menu">
    <li v-for="(navItem, indexA) in mainNav" :key="indexA">
      <div>
        <button
          class="-outline-offset-1 flex p-4 border-b fluid-xs leading-snug uppercase font-medium w-full justify-between items-center transition-all"
          :class="{ 'border-br-green': openIndex === indexA }"
          :tabindex="openIndex === null ? '0' : '-1'"
          :aria-expanded="openIndex === indexA ? 'true' : 'false'"
          @click="onButtonClick(indexA)"
        >
          {{ navItem.title }}
          <IconChevron class="transform transition-all" :class="{ '-rotate-90': openIndex !== indexA }" />
        </button>
      </div>

      <transition
        enter-class="translate-x-full opacity-0"
        enter-to-class="translate-x-0 opacity-100"
        enter-active-class="transition duration-200 ease-in-out"
        leave-class="translate-x-0 opacity-100"
        leave-to-class="translate-x-full opacity-0"
        leave-active-class="transition duration-200 ease-in-out"
      >
        <ChildNavigation
          v-if="openIndex === indexA"
          class="fixed w-80 left-0 right-0 bottom-0 top-12 z-10 bg-white overflow-y-auto"
          v-bind="{ navItem }"
          @closeMenu="closeChildNav"
          ref="activeChildNavigation"
        />
      </transition>
    </li>
  </ul>
</template>

<script setup>
import { ref, computed, watch, nextTick } from 'vue';
import { useMainNavStore } from '@/stores/main-nav';
import IconChevron from '@/components/layout/header/IconChevron';
import ChildNavigation from '@/components/layout/header/mobileDrawer/ChildNavigation';

// Props
const props = defineProps({
  title: {
    type: String,
    default: '',
  },
});

// Emits
const emit = defineEmits(['onClick', 'child-navigation-opened', 'child-navigation-closed']);

// State
const openIndex = ref(null);
const navContainer = ref(null);
const activeChildNavigation = ref(null);

// Store
const mainNavStore = useMainNavStore();
const mainNav = computed(() => mainNavStore.mainNav);
const close = () => mainNavStore.close();

// Methods
const onButtonClick = (index) => {
  emit('onClick');
  if (openIndex.value === index) {
    collapseOpenNav();
  } else {
    openIndex.value = index;
    nextTick(() => {
      activeChildNavigation.value = index;
      emit('child-navigation-opened', index);
    });
  }
};

const collapseOpenNav = () => {
  openIndex.value = null;
  activeChildNavigation.value = null;
};

const closeChildNav = () => {
  openIndex.value = null;
  activeChildNavigation.value = null;
  emit('child-navigation-closed');
};

// Watch for changes to openIndex
watch(openIndex, (newValue, oldValue) => {
  if (oldValue !== null && newValue === null) {
    // When closing child navigation, emit event
    emit('child-navigation-closed');
  }
});
</script>
